import React from 'react';
import { motion } from 'framer-motion';

export default function Stakeholders() {
  const groups = [
    {
      title: "For parents who need to be heard.",
      desc: "You reported it. You followed up. You deserved better. Veric makes sure you get it."
    },
    {
      title: "For schools ready to show they care.",
      desc: "Most schools want to do the right thing. Veric gives them the tools and the recognition to prove it."
    },
    {
      title: "For students who deserve to feel safe.",
      desc: "Not someday. Not after the next incident. Now."
    }
  ];

  return (
    <section className="w-full py-24 md:py-40 bg-navy text-white -mx-6 md:-mx-12 px-6 md:px-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12">
        {groups.map((group, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
            className="flex flex-col gap-4"
          >
            <h3 className="text-2xl md:text-3xl font-bold leading-tight">
              {group.title}
            </h3>
            <p className="text-lg text-white/70 leading-relaxed font-medium">
              {group.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}